/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NotificationChannelWebhookUrl } from './NotificationChannelWebhookUrl';
import {
    NotificationChannelWebhookUrlFromJSON,
    NotificationChannelWebhookUrlFromJSONTyped,
    NotificationChannelWebhookUrlToJSON,
    NotificationChannelWebhookUrlToJSONTyped,
} from './NotificationChannelWebhookUrl';
import type { NotificationChannelEmail } from './NotificationChannelEmail';
import {
    NotificationChannelEmailFromJSON,
    NotificationChannelEmailFromJSONTyped,
    NotificationChannelEmailToJSON,
    NotificationChannelEmailToJSONTyped,
} from './NotificationChannelEmail';
import type { ChannelTypeEnum } from './ChannelTypeEnum';
import {
    ChannelTypeEnumFromJSON,
    ChannelTypeEnumFromJSONTyped,
    ChannelTypeEnumToJSON,
    ChannelTypeEnumToJSONTyped,
} from './ChannelTypeEnum';

/**
 * Serializer for notification channels.
 * @export
 * @interface PatchedNotificationChannelRequest
 */
export interface PatchedNotificationChannelRequest {
    /**
     * 
     * @type {number}
     * @memberof PatchedNotificationChannelRequest
     */
    owner?: number | null;
    /**
     * 
     * @type {ChannelTypeEnum}
     * @memberof PatchedNotificationChannelRequest
     */
    channelType?: ChannelTypeEnum;
    /**
     * 
     * @type {NotificationChannelEmail}
     * @memberof PatchedNotificationChannelRequest
     */
    email?: NotificationChannelEmail | null;
    /**
     * 
     * @type {NotificationChannelWebhookUrl}
     * @memberof PatchedNotificationChannelRequest
     */
    webhookUrl?: NotificationChannelWebhookUrl | null;
}



/**
 * Check if a given object implements the PatchedNotificationChannelRequest interface.
 */
export function instanceOfPatchedNotificationChannelRequest(value: object): value is PatchedNotificationChannelRequest {
    return true;
}

export function PatchedNotificationChannelRequestFromJSON(json: any): PatchedNotificationChannelRequest {
    return PatchedNotificationChannelRequestFromJSONTyped(json, false);
}

export function PatchedNotificationChannelRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchedNotificationChannelRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'owner': json['owner'] === undefined ? undefined : json['owner'] === null ? null : json['owner'],
        'channelType': json['channel_type'] == null ? undefined : ChannelTypeEnumFromJSON(json['channel_type']),
        'email': json['email'] === undefined ? undefined : json['email'] === null ? null : NotificationChannelEmailFromJSON(json['email']),
        'webhookUrl': json['webhook_url'] === undefined ? undefined : json['webhook_url'] === null ? null : NotificationChannelWebhookUrlFromJSON(json['webhook_url']),
    };
}

export function PatchedNotificationChannelRequestToJSON(json: any): PatchedNotificationChannelRequest {
    return PatchedNotificationChannelRequestToJSONTyped(json, false);
}

export function PatchedNotificationChannelRequestToJSONTyped(value?: PatchedNotificationChannelRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'owner': value['owner'],
        'channel_type': ChannelTypeEnumToJSON(value['channelType']),
        'email': NotificationChannelEmailToJSON(value['email']),
        'webhook_url': NotificationChannelWebhookUrlToJSON(value['webhookUrl']),
    };
}

